// src/modules/competition/hooks/useCompetitionData.js
import { useState, useEffect, useCallback } from 'react';
import { useService } from '../../../shared/hooks/useService';

export const useCompetitionData = (competitionId) => {
    const [competition, setCompetition] = useState(null);
    const [competitors, setCompetitors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const service = useService();

    const loadCompetitionData = useCallback(async () => {
        try {
            setIsLoading(true);
            const data = await service.getCompetitionDetails(competitionId);

            setCompetition({
                ...data.competition
            });
            setCompetitors(data.competition.competitors);
            setError(null);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, [competitionId, service]);

    useEffect(() => {
        loadCompetitionData();
    }, [loadCompetitionData]);

    return {
        competition,
        competitors,
        isLoading,
        error,
        reloadData: loadCompetitionData
    };
};
